import React from 'react';

import Scope from './scope';
import KeyTermsUsed from './key-terms-used';
import Prerequisites from './prerequisites';
import ApiKey from './api-key';
import ProcessDescription from './process-description';
import XmlFormat from './xml-format';
import XmlValidation from './xml-validation';
import EnsureXmlAndImages from './ensure-files-inplace';
import CreatingZipFile from './creating-zip-file';
import UploadingZipToPortal from './uploading-zip-to-portal';
import HtmlEncoding from './html-encoding';
import FieldsDescription from './field-description';
import ProductCodes from './product-codes';
import ProductCodeExamples from './product-code-examples';
import GpcMoreInfo from './gpc-more-info';
import ComplexFieldImages from './complex-field-images';
import ApiTechnicalDetails from './api-technical-details';

import { startsWith } from 'lodash';

import { MENU_ENTRIES } from './constants';

const CurrentSection = ({ section, onSectionChange }) => {
  if (section === MENU_ENTRIES.scope) return <Scope/>;
  if (section === MENU_ENTRIES.keyTermsUsed) return <KeyTermsUsed/>;
  if (section === MENU_ENTRIES.prerequisites) return <Prerequisites onSectionChange={onSectionChange}/>;
  if (section === MENU_ENTRIES.overviewOfDataUploadingProcess) return <ProcessDescription onSectionChange={onSectionChange}/>;
  if (section === MENU_ENTRIES.htmlEncoding) return <HtmlEncoding/>;
  if (section === MENU_ENTRIES.productCodesXmlExamples) return <ProductCodeExamples/>;
  if (section === MENU_ENTRIES.gpcMoreInformation) return <GpcMoreInfo/>;
  if (section === MENU_ENTRIES.apiTechnicalDetails) return <ApiTechnicalDetails/>;
  if (section === MENU_ENTRIES.ensureXmlAndImagesInOneFolder) return <EnsureXmlAndImages onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.creatingZipFile)) return <CreatingZipFile/>;
  if (startsWith(section, MENU_ENTRIES.uploadingZipToPortal)) return <UploadingZipToPortal onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.apiKey)) return <ApiKey/>;
  if (startsWith(section, MENU_ENTRIES.xmlValidation)) return <XmlValidation onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.creatingRecallInXmlFormat)) return <XmlFormat onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.fieldsDescription)) return <FieldsDescription onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.productCodes)) return <ProductCodes onSectionChange={onSectionChange}/>;
  if (startsWith(section, MENU_ENTRIES.complexFieldImages)) return <ComplexFieldImages/>;

  return <Scope/>;
};

export default CurrentSection;


// WEBPACK FOOTER //
// ./src/views/static/import-documentation/current-section.js